import React from 'react';

import CompanyTable from '../Table';

export default () => {
  return <CompanyTable />;
};
